import Swiper from "swiper/swiper-bundle";
//import "swiper/swiper-bundle.min.css";

const HomeSlider = (el) => {
    const swiper = new Swiper(el, {
        direction: 'horizontal',
        loop: false ,      
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
    });
    if (swiper.slides.length <= 1 || el.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)').length <= 1) {
      swiper.allowTouchMove = false;

     
    }
}

export default HomeSlider